// extracted by mini-css-extract-plugin
module.exports = {"text-color":"#021135","textColor":"#021135","color-grimace-purple":"#8735EA","colorGrimacePurple":"#8735EA","productCard":"_18xWY"};